module Meevo.Plugins.DrawerManager {
    "use strict";

    export class CashTransactionsSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        public isClosing: boolean = false;
        public paymentTypeId: string;
        public transactions: Meevo.Components.BaseClasses.PagedResults<Meevo.Model.PaymentTransaction, Meevo.Model.PaymentTransactionCriteria>;
        public summary: any[] = [];
        public numTransactions: number;
        public expectedTotal: number;
        public payInOutSummary;

        constructor(
            drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader: boolean,
            personalFooter: boolean) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.CashTransactions, drawerManagerContext, "cashTransactions", personalHeader, personalFooter);
        }

        reset() {
            super.reset();
            this.transactions = new Meevo.Components.BaseClasses.PagedResults<Meevo.Model.PaymentTransaction, Meevo.Model.PaymentTransactionCriteria>(this.dataService, this.appSettings.API_ENDPOINTS.drawerSession + "/" + this.context.selectedDrawer.drawerSession.id + "/Transaction", null, null, null, null, true);
            if (this.context && this.context.selectedDrawer && this.context.selectedDrawer.drawerSession && this.context.selectedDrawer.drawerSession.drawerSessionHistory) {
                for (var i = this.context.selectedDrawer.drawerSession.drawerSessionHistory.length - 1; i >= 0; i--) {
                    let item = this.context.selectedDrawer.drawerSession.drawerSessionHistory[i];
                    if (item.drawerState == Meevo.Model.DrawerStateEnum.Open) {
                        this.context.mostRecentHistoryForOpen = item;
                    }
                }
            }
            this.context.getCashTransactionPaymentType()
                .then(paymentTypeId => {
                    this.getTransactions(paymentTypeId);
                });
            this.payInOutSummary = this.context.getDrawerSessionPayInOut(Model.PaymentCategoryEnum.Cash) || [];
        }

        initialize(paymentTypeId: string, isClosing: boolean) {
            this.isClosing = isClosing;
            this.paymentTypeId = paymentTypeId;
            this.getTransactions(paymentTypeId);
        }

        getTransactions(paymentTypeId): any {
            let transactionRequest = {
                pageNumber: 0,
                itemsPerPage: 20,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    drawerId: this.context.selectedDrawer.id,
                    paymentTypeId: paymentTypeId
                }
            };
            this.transactions.initSearch(transactionRequest).then((results) => {
                this.expectedTotal = results.amount;
                this.numTransactions = results.count;
            });
            this.transactions.clearSearch();

        }
        
        getPayInOutTotal(): number {
            let total: number = 0;

            if (this.payInOutSummary) {
                for (var i = 0; i < this.payInOutSummary.length; i++) {
                    total += (this.payInOutSummary[i].cashAmount * (this.payInOutSummary[i].payInOutType==Meevo.Model.PayInOutEnum.PayOut? -1 : 1));
                }
                total += this.context.selectedDrawer.drawerSession.openCashAmount;
            }
            return total;
        }

        close() {
            this.context.closeSection();
        }

    }

}